
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kits",
      function () {
        return require("private-next-pages/kits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kits"])
      });
    }
  